// extracted by mini-css-extract-plugin
export default {"SportContainer":"sport_SportContainer__1n9gi","SportContent":"sport_SportContent__9befG"};